"use client"

import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { setActiveTab } from "../../store/features/cvUpload/cvUploadSlice";
import { CVUploadState } from "../../components/cv-upload/types";

import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { UploadTab } from "./UploadTab";
import { EditTab } from "./EditTab";
import { ReviewTab } from "./ReviewTab";

export default function CVUpload() {
  const dispatch = useAppDispatch();
  const { activeTab, extractedData } = useAppSelector((state) => state.cvUpload as CVUploadState);

  return (
    <Tabs 
      value={activeTab} 
      onValueChange={(value) => dispatch(setActiveTab(value))} 
      className="w-full"
    >
      <TabsList className="grid w-full grid-cols-3">
        <TabsTrigger value="upload">Upload CV</TabsTrigger>
        <TabsTrigger value="profile">
          Profile Info
        </TabsTrigger>
        <TabsTrigger value="review" disabled={!extractedData}>
          Review
        </TabsTrigger>
      </TabsList>

      <TabsContent value="upload">
        <UploadTab />
      </TabsContent>

      <TabsContent value="profile">
        <EditTab />
      </TabsContent>

      <TabsContent value="review">
        <ReviewTab />
      </TabsContent>
    </Tabs>
  );
} 